import { syncHistoryWithStore } from 'react-router-redux';
import createStore from 'store';
import network from 'utils/network';
import { LoginWatcher } from 'utils/loginWatcher';
import createRouterHistory from 'utils/createRouterHistory';

import { gtm } from 'apps/gtm';
import { wa } from 'apps/analytics';
import { dataSync } from 'apps/dataSync';
import routeMonitor from 'utils/routeMonitor';

const initialState = window.INITIAL_STATE;
delete window.INITIAL_STATE;

const loginWatcher = new LoginWatcher();

const routerHistory = createRouterHistory();
const store = createStore(routerHistory, initialState, { network, loginWatcher });
const history = syncHistoryWithStore(routerHistory, store);

gtm.setStore(store);
dataSync.setStore(store);
network.setStore(store);
network.setHistory(routerHistory);
wa.setStore(store);
routeMonitor.setStore(store);

export {
  store,
  history,
  network,
  dataSync,
};
